/// <amd-module name="Environments/EnvironmentsCommon/Constants" />
export namespace CommonConstants {
    export const NamespaceId = "83d4c2e6-e57d-4d6e-892b-b87222b7ad20";
    export const NamespaceSeparator = "/";
    export const AdminPermission = 8;
    export const Environment = "Environments";
}
